/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import PatchManager from "App/utils/globe/chunk_lod/patch_manager";
import Visitor, {VisitorOrdering} from "App/utils/globe/chunk_lod/visitor";
import TreeNode from "App/utils/globe/chunk_lod/tree/node";

export default
class PriorityManager extends Visitor {
    private _patch: PatchManager;
    private _priority: Uint8Array;
    private _needPriorityUpdate: boolean;

    constructor(aPatch: PatchManager) {
        super();

        this._visiteeConsumerFunction = this.manage.bind(this);
        this._ordering = VisitorOrdering.pre;

        this._patch = aPatch;

        this._needPriorityUpdate = false;
        this._priority = null;
        this.clearPriority();
    }

    public clearPriority() {
        let patchInfo = this._patch.getPatchInfo();
        this._priority = new Uint8Array(TreeNode.getFlattenedTreeSize(patchInfo.levels, patchInfo.nc));
    }

    public getPriority(aVisitee: TreeNode) {
        return this._priority[aVisitee.getAddress().flattenedTreeIndex];
    }

    public updatePriority(aVisitee: TreeNode) {
        let parent = aVisitee.getParent();
        if (parent) {
            this.updatePriority(parent);

            // distribute the priority to all four tiles as we need all of the to switch to show only one of them
            let childrenOfParent = parent.getChildren();
            for (let i = 0; i < childrenOfParent.length; i++) {
                this._priority[childrenOfParent[i].getAddress().flattenedTreeIndex]++;
            }
        } else {
            this._priority[aVisitee.getAddress().flattenedTreeIndex]++;
        }
    }

    public manage(aVisitee: TreeNode) {
        if (this._needPriorityUpdate) {
            this.updatePriority(aVisitee);
        }
    }

    public invalidatePriority() {
        this.clearPriority();
        this._needPriorityUpdate = true;
    }
}
